import { render } from "./ViewInterviewAttachments.vue?vue&type=template&id=26db4dc6&scoped=true"
import script from "./ViewInterviewAttachments.vue?vue&type=script&lang=js"
export * from "./ViewInterviewAttachments.vue?vue&type=script&lang=js"

import "./ViewInterviewAttachments.vue?vue&type=style&index=0&id=26db4dc6&scoped=true&lang=scss"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26db4dc6"]])

export default __exports__